import { render, staticRenderFns } from "./SwithLanguage.vue?vue&type=template&id=e2b5bc12&scoped=true&"
import script from "./SwithLanguage.vue?vue&type=script&lang=js&"
export * from "./SwithLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SwithLanguage.vue?vue&type=style&index=0&id=e2b5bc12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b5bc12",
  null
  
)

export default component.exports